import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetSingleAgentData = async (agentId) => {
  /**
   * input: null
   * output: agent object
   * description: fetches Single agent
   */

  try {
    const clientsDocument = await doc(
      db,
      "clients",
      getLocalStorageItem("bid")
    );
    const agentCollection = await collection(clientsDocument, "agents");
    const agentDocument = await doc(agentCollection, agentId);
    const agentSnapshot = await getDoc(
      agentDocument,
      where("bid", "==", getLocalStorageItem("bid")),
      where("is_deleted", "==", false)
    );

    const agent = { id: agentSnapshot.id, ...agentSnapshot.data() };
    return agent;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleAgentData;
